import {_} from 'lodash';
import {ISyncField} from '../../index';
import {ObjectTypeId} from "../../constants";
import {getSourceTranslation} from "../../util/misc";
import {nsTooltip} from "../../util/nsTooltip";
import {lm, lm_} from "../../appContext";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import syncfield_nameHtml from './syncfield-name.html?raw';

export let template = syncfield_nameHtml;

interface IParams {
    id?: number;
    key?: string
    objecttypeid?: ObjectTypeId[]
    syncfield?: ISyncField
    processOutput?: (str: string) => string
}

export class viewModel {
    private readonly id: number | undefined;
    private readonly key: string | undefined;
    private readonly objecttypeid: ObjectTypeId[];
    private readonly syncfield: ISyncField | undefined
    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()

    constructor(private params: IParams) {
        this.syncfield = params.syncfield
        this.id = params.id
        this.key = params.key
        this.objecttypeid = (params.objecttypeid
            ? Array.isArray(params.objecttypeid)
                ? params.objecttypeid
                : [params.objecttypeid]
            : [this.syncfield?.objecttypeid])
            .filter((id): id is ObjectTypeId => id != null)
    }

    private getLabel() {
        const translation = this.getSyncfieldTranslation();
        if (!translation) {
            return '';
        }
        let ret = getSourceTranslation(translation)
        const processOutput = this.params.processOutput;
        if (processOutput) {
            ret = processOutput(ret)
        }
        return ret
    }

    private getTitle() {
        const translation = this.getSyncfieldTranslation();
        if (!translation) {
            return '';
        }
        return lm.t(nsTooltip.getTitle_syncfield(translation) ?? '')
    }

    private getSyncfieldTranslation(): ISyncField | undefined {
        let sf: ISyncField | undefined
        if (this.objecttypeid && this.id) {
            sf = this.getTranslation()
                .find(sf => sf.syncfieldid == this.id)
        } else if (this.objecttypeid && this.key) {
            sf = this.getTranslation()
                .find(sf => sf.name == this.key)
        } else if (this.syncfield) {
            sf = this.getTranslation()
                .find(sf => sf.syncfieldid == this.syncfield!.syncfieldid)
        }
        return sf
    }

    private getTranslation(): ISyncField[] {
        return _(this.objecttypeid)
            .map((objectTypeId: ObjectTypeId) => lm_.getInstance(objectTypeId))
            .filter(Boolean)
            .map((o: ReturnType<typeof lm_.getInstance>) => o!.translations())
            .flatten()
            .value()
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }
}
